;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="c2077991-9b9e-49a3-991f-985b181e0c66",e._sentryDebugIdIdentifier="sentry-dbid-c2077991-9b9e-49a3-991f-985b181e0c66")}catch(e){}}();import loadable from '@loadable/component';
import dynamic from 'next/dynamic';
import '../../_virtual/_sentry-release-injection-file.js';

const getHeaderAccountFlyout = (isNextJS) => {
    return isNextJS
        ? dynamic(() => import('@zooplus/header-account-flyout'), {
            ssr: false,
        })
        : loadable(() => import('@zooplus/header-account-flyout'));
};

export { getHeaderAccountFlyout as default };
//# sourceMappingURL=HeaderAccountFlyoutWrapper.js.map
